import styled from "styled-components";

const ButtonGroup = styled.div`
  display: flex;
  margin-top: 1rem;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;

  @media screen and (max-width: 576px) {
  }
`;

export default ButtonGroup;
